/* Marchetti Firenze: verticale aankondigingsbalk. Elke X sec 1 tekst omhoog, oneindige lus. */
(function(){
  function init(bar){
    if(!bar||bar.dataset.mfInit)return; bar.dataset.mfInit='1';
    var track=bar.querySelector('.mf-ann__track'); if(!track)return;
    var items=track.children; var n=items.length; if(n<2)return;
    track.appendChild(items[0].cloneNode(true));
    var delay=parseInt(bar.dataset.delay,10)||5000, speed=parseInt(bar.dataset.speed,10)||500, i=0, h=function(){return items[0].offsetHeight||15;};
    function go(){
      i++; track.style.transition='transform '+speed+'ms ease'; track.style.transform='translate3d(0,'+(-i*h())+'px,0)';
      if(i===n){setTimeout(function(){track.style.transition='none';i=0;track.style.transform='translate3d(0,0,0)';},speed+20);}
    }
    var t=setInterval(go,delay);
    document.addEventListener('visibilitychange',function(){clearInterval(t);if(!document.hidden)t=setInterval(go,delay);});
  }
  function all(){document.querySelectorAll('.mf-ann').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',all);
})();
